import React, { PropsWithChildren, Suspense, useEffect, useLayoutEffect, useRef } from 'react';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { IModalWrapperProps } from './modal.interface';
import { ModalErrorBoundary } from './errorBoundary';
import { Dialog } from './dialog';

export interface IDialogModalProps extends PropsWithChildren, IModalWrapperProps {}
export const DialogModal: React.FC<IDialogModalProps> = ({ ContentComponent, contentProps, open, onClose, onClosed }) => {
  useLayoutEffect(() => Dialog.register('yh-dialog'), []);
  const ref = useRef<Dialog>(null);
  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.onClose = onClose;
      el.onClosed = onClosed;
    }
  }, [onClose, onClosed]);
  return (
    /* @ts-expect-error custom element */
    <yh-dialog open={open} ref={ref}>
      <ModalErrorBoundary>
        <Suspense
          fallback={
            <ModalLayout>
              <ModalContainer>
                <ContentSkeleton blocks={2} />
              </ModalContainer>
            </ModalLayout>
          }
        >
          <ContentComponent {...contentProps} />
        </Suspense>
      </ModalErrorBoundary>
      {/* @ts-expect-error custom element */}
    </yh-dialog>
  );
};
